// src/components/BulkOperations/BulkDeviceResultRow.js
import React from "react";
import PropTypes from "prop-types";

/**
 * BulkDeviceResultRow - Individual device result display in bulk operation
 *
 * Shows device name, cloud response status, device reaction status, and timers
 */
const BulkDeviceResultRow = ({
  result,
  deviceState,
  actionStatus,
  deviceLockState,
  expectedState,
  deviceTimer,
}) => {
  const formatTime = (ms) => {
    if (!ms) return "00:00.000";
    const totalSeconds = ms / 1000;
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = Math.floor(totalSeconds % 60);
    const milliseconds = Math.floor(ms % 1000);
    return `${minutes.toString().padStart(2, "0")}:${seconds
      .toString()
      .padStart(2, "0")}.${milliseconds.toString().padStart(3, "0")}`;
  };

  const formatTimestamp = (ms) => {
    if (!ms) return "";
    const date = new Date(ms);
    return date.toISOString();
  };

  const truncateId = (id) => {
    if (!id) return "";
    return id.substring(0, 8) + "...";
  };

  return (
    <div className="bulk-device-result">
      <div className="cell-device-name">
        {deviceState?.displayName || "Unknown"}
      </div>
      <div className="cell-device-id" title={result.deviceId}>
        {truncateId(result.deviceId)}
        <button
          className="copy-btn"
          onClick={() => navigator.clipboard.writeText(result.deviceId)}
        >
          📋
        </button>
      </div>
      <div className="cell-action-id" title={result.actionId}>
        {truncateId(result.actionId)}
        <button
          className="copy-btn"
          onClick={() => navigator.clipboard.writeText(result.actionId)}
        >
          📋
        </button>
      </div>
      <div className="cell-action-status">
        <span
          className={`status-badge status-${
            actionStatus?.toLowerCase() || "pending"
          }`}
        >
          {actionStatus || "PENDING"}
        </span>
      </div>
      <div className="cell-lockdown-state">{deviceLockState || "Unknown"}</div>
      <div className="cell-lock-state">
        {deviceState?.lockState || "Unknown"}
      </div>
      <div className="cell-cloud-time">
        <div className="time-display">
          {deviceTimer && (
            <>
              <span className="time-value">
                ⏱ {formatTime(deviceTimer.cloudElapsed)}
              </span>
              <span className="time-timestamp">
                Started: {formatTimestamp(deviceTimer.cloudStartTime)}
              </span>
            </>
          )}
        </div>
      </div>
      <div className="cell-device-time">
        <div className="time-display">
          {deviceTimer && (
            <>
              <span className="time-value">
                ⏱ {formatTime(deviceTimer.deviceElapsed)}
              </span>
              <span className="time-timestamp">
                Started: {formatTimestamp(deviceTimer.deviceStartTime)}
              </span>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

BulkDeviceResultRow.propTypes = {
  result: PropTypes.object.isRequired,
  deviceState: PropTypes.object,
  actionStatus: PropTypes.string,
  deviceLockState: PropTypes.string,
  expectedState: PropTypes.string.isRequired,
  deviceTimer: PropTypes.shape({
    cloudElapsed: PropTypes.number,
    deviceElapsed: PropTypes.number,
    cloudStopped: PropTypes.bool,
    deviceStopped: PropTypes.bool,
  }),
};

export default BulkDeviceResultRow;
